import { render, staticRenderFns } from "./GapList.vue?vue&type=template&id=cfac1cae&"
import script from "./GapList.vue?vue&type=script&lang=ts&"
export * from "./GapList.vue?vue&type=script&lang=ts&"
import style0 from "./GapList.vue?vue&type=style&index=0&scopedx=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports